"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var wikom_data_1 = require("@wikom/wikom-data");
var constants_1 = require("../../../constants");
var EditComponent_1 = __importDefault(require("./EditComponent"));
var actions_1 = require("../../../actions");
var EditContainer = function (_a) {
    var _b;
    var grid = _a.grid, rowId = _a.rowId, colId = _a.colId, idx = _a.idx, component = _a.component, rowData = _a.rowData, editRoute = _a.editRoute, submitStatus = _a.submitStatus, onFocus = _a.onFocus, onBlur = _a.onBlur, cellInEdit = _a.cellInEdit;
    var wrapperClass = (0, classnames_1["default"])({
        'ajaxsubmit-wrapper': true,
        'ajaxsubmit-error': submitStatus === constants_1.SUBMIT_STATUS_FAILURE,
        'ajaxsubmit-loading': submitStatus === constants_1.SUBMIT_STATUS_PENDING,
        'ajaxsubmit-success': submitStatus === constants_1.SUBMIT_STATUS_SUCCESS
    });
    return react_1["default"].createElement(EditComponent_1["default"], {
        // @ts-ignore
        component: component,
        form: 'gridedit_' + grid + '_' + rowId + '_' + colId,
        grid: grid,
        idx: idx,
        initialValues: (_b = {}, _b[idx] = (0, find_in_object_1["default"])(idx, rowData), _b),
        onSubmit: function (values, dispatch, props) { return dispatch((0, actions_1.handleSubmit)(values, grid, rowData, editRoute)); },
        onSubmitFail: function (errors, dispatch, submitError, props) {
            if (submitError.status === 422) {
                var error = {
                    status: 422,
                    response: {
                        body: {
                            name: 'Die Angaben des Formulars enthalten schwerwiegende Fehler.',
                            // @ts-ignore
                            message: []
                        }
                    }
                };
                for (var _i = 0, _a = submitError.response.body; _i < _a.length; _i++) {
                    var errorMessage = _a[_i];
                    error.response.body.message.push(errorMessage.message);
                }
                // @ts-ignore
                dispatch(wikom_data_1.actions.loadDataFailure({ error: error }));
            }
        },
        onFocus: onFocus,
        onBlur: onBlur,
        submitStatus: submitStatus,
        cellInEdit: cellInEdit,
        wrapperClass: wrapperClass,
        disabled: submitStatus === constants_1.SUBMIT_STATUS_PENDING,
        enableReintialize: true
    });
};
exports["default"] = EditContainer;
